import { useEffect, useState, useRef, Fragment } from "react";

const dropdown = (align = "start") => {
	return {
		position: "relative",
		display: "inline-flex",
		justifyContent: align,
		gap: "20px",
		width: "100%",
		maxWidth: "500px",
	}
};

const dropdownButton = {
	display: "flex",
	justifyContent: "space-between",
	width: "fit-content",
	padding: "8px 12px",
	border: "1px solid #ccc",
	backgroundColor: "#fff",
	textAlign: "left",
	cursor: "pointer",
	borderRadius: "4px",
};

const dropdownMenu = {
	position: "absolute",
	top: "100%",
	// left: 0,
	// left: "calc(50% - 100px)",
	maxHeight: "300px",
	overflowY: "auto",
	zIndex: 10,
	width: "fit-content",
	background: "white",
	border: "1px solid #ccc",
	borderRadius: "4px",
	marginTop: "4px",
	boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
};

const dropdownItem = {
	padding: "8px 12px",
	display: "flex",
	alignItems: "center",
    gap: "10px",
	cursor: "pointer",
};

const DropdownCheckList = (props) => {
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState(null);
	const dropdownRef = useRef();

    useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	useEffect(() => {
        if (props.items && props.items.length > 0) {
            setSelected(props.items);
        } else {
            setSelected(null);
        }
    }, [props.items]);

    useEffect(() => {
		if(selected)
        	props.setItems(selected);
		if(selected && selected.length === 0) {
			setSelected(null);
		}
    }, [selected]);

	const toggleOption = (item, index) => {
		if (index === 0) {
			setSelected([props.list[0]]);
		} else if (index === 1) {
			setSelected([props.list[1]]);
		} else {
			if (selected?.some(x => x.type === props.list[0].type && x.value === props.list[0].value)
				|| selected?.some(x => x.type === props.list[1].type && x.value === props.list[1].value)
			) {
				setSelected([{...props.list[index], value: item}]);
			} else {
				if (!selected) setSelected([{...props.list[index], value: item}]);
				else {
					const isSelected = selected?.some((x) => x.value === item);
					let newSelected = [...selected];
					if (isSelected) {
						newSelected = newSelected.filter((x) => x.value !== item);
						if (newSelected.length === 0) {
							newSelected = [props.list[0]];
						}
					} else {
						newSelected.push({...props.list[index], value: item});
					}
					setSelected(newSelected);
				}
			}
		}
        // setOpen(false);
	};

	const handleClickOutside = (e) => {
		if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
			setOpen(false);
		}
	};

	return (
		<div className="dropdown option-btm" ref={dropdownRef} style={dropdown(props.align)}>
			{props.disabled ? 
				<span>
					{!selected || selected.length === 0
						? props.list[0]?.name
						: selected?.map((x) => x.type === "dept" ? x.value : x.name).join(", ")}
				</span>
			: 
				<button
					className="dropdown-button"
					onClick={() => setOpen(!open)}
					style={dropdownButton}
				>
					{!selected || selected.length === 0
						? props.list[0]?.name
						: selected?.map((x) => x.type === "dept" ? x.value : x.name).join(", ")}
					<div style={{ transform: open ? "" : "rotate(180deg)" }}>
						<i className="icoKdc16 expand"></i>
					</div>
				</button>
			}
			{open && (
				<div className="dropdown-menu" style={dropdownMenu}>
					{props.list.map((item, index) => (
						<Fragment key={index}>
							<label
								// key={item.type}
								className="dropdown-item"
								style={{...dropdownItem, color: item.isSelect ? "#333" : "#aaa"}}
							>
								{item.isSelect && (
									<input
										type="checkbox"
										checked={(!selected && index === 0) || selected?.some((x) => x.value === item.value)}
										onChange={() => toggleOption(item.value, index)}
										className="dropdown-checkbox"
									/>
								)}
								{item.name}
							</label>
							{/* {props.subList && Object.keys(props.subList).length > 0 &&
								props.subList.type === item.type && 
								props.subList.list.map((sub, subIndex) => (
									<label
										key={subIndex}
										className="dropdown-item"
										style={dropdownItem}
									>
										<input
											type="checkbox"
											checked={selected?.some((x) => x.value === sub.deptName)}
											onChange={() => toggleOption(sub.deptName, index)}
											className="dropdown-checkbox"
										/>
										{sub.deptName}
									</label>
								))
							} */}
						</Fragment>
					))}
				</div>
			)}
		</div>
	);
};

export default DropdownCheckList;
